module.exports = __webpack_public_path__ + "img/20_108.11b96722.png";